module.exports = __webpack_public_path__ + "static/media/bubble-msg-04-eng.9504d1f2.png";